import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import type { IdentityClient } from '@/auth/identity-client';
import { AuthProvider } from '@/auth/session';
import { InspectorProvider } from '@/inspector/inspector-context';

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 60_000 },
    },
  });
}

export function Providers({
  children,
  initialPersonaId,
  queryClient,
  identityClient,
}: {
  children: ReactNode;
  initialPersonaId?: string;
  queryClient?: QueryClient;
  identityClient?: IdentityClient | null;
}) {
  const [client] = useState(() => queryClient ?? createQueryClient());
  return (
    <QueryClientProvider client={client}>
      <AuthProvider initialPersonaId={initialPersonaId} identityClient={identityClient}>
        <InspectorProvider>{children}</InspectorProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
